import ApolloErrorBoundary from '@/components/ApolloErrorBoundary';
import { GateMovementBanner } from '@/features';
import { useSelector } from '@/store';
import { Box, Theme, useMediaQuery } from '@mui/material';
import { useEffect, type FC, type ReactNode } from 'react';
import { Helmet } from 'react-helmet-async';
import { useDispatch } from 'react-redux';
import { Outlet, useLocation } from 'react-router-dom';
import { setCollapsedSidebar, setOpenSidebarDrawer } from '../slices/sidebarSlice';
import { Navbar } from './navbar';
import { Sidebar } from './sidebar';

interface DashboardLayoutProps {
  children?: ReactNode;
}

export const DashboardLayout: FC<DashboardLayoutProps> = () => {
  const { collapsedSidebar, openSidebarDrawer } = useSelector((state) => state.dashboard_store);
  const dispatch = useDispatch();
  const lgUp = useMediaQuery<Theme>((theme) => theme.breakpoints.up('lg'));
  const location = useLocation();

  const toggleSidebar = () => {
    if (lgUp) {
      dispatch(setCollapsedSidebar(!collapsedSidebar));
    } else {
      dispatch(setOpenSidebarDrawer(!openSidebarDrawer));
    }
  };

  const onCloseDrawer = () => {
    dispatch(setOpenSidebarDrawer(false));
  };

  // Close drawer on url change
  useEffect(() => {
    setTimeout(() => {
      dispatch(setOpenSidebarDrawer(false));
    }, 1);
  }, [location, dispatch]);

  return (
    <>
      <Helmet>
        <title>Capta Hydro | Amaru</title>
      </Helmet>
      <Box
        height="100%"
        display="grid"
        gridTemplateColumns={{ xs: '1fr', lg: 'auto 1fr' }}
        gridTemplateRows="auto 1fr"
      >
        <Navbar toggleSidebar={toggleSidebar} />
        <Sidebar collapsed={collapsedSidebar} open={openSidebarDrawer} onClose={onCloseDrawer} />
        <Box height="100%" overflow="auto">
          <ApolloErrorBoundary>
            <Outlet />
          </ApolloErrorBoundary>
        </Box>
        <Box sx={{ gridColumn: '1 / span 2' }}>
          <GateMovementBanner />
        </Box>
      </Box>
    </>
  );
};
